import React from "react";

/**
 * Context to hold the sponsor code
 * @type {React.Context<null>}
 */
const SponsorCodeContext = React.createContext(null);

export default SponsorCodeContext;
